import { useEffect } from "react";
import Button from "../../components/Button";

export default function NotFound() {
  useEffect(() => {
    document.title = "Page not found - Aldebaran";
  }, []);

  return (
    <div className="page">
      <div className="page__container">
        <div className="page__hero">
          <p className="page__eyebrow">Error 404</p>
          <h1 className="page__title">This page drifted off-chain</h1>
          <p className="page__lead">
            The page you're looking for doesn't exist or has moved. Let's get
            you back to Aldebaran.
          </p>
          <div className="mt-8 flex justify-center">
            <Button to="/" className="btn--lg">
              Back home
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
